
import React from "react";
import { motion } from "framer-motion";
import { Calendar, FileCheck, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

const Vote = () => {
  const votingSteps = [
    {
      icon: <Calendar className="w-12 h-12 text-primary" />,
      title: "Fecha y lugar de la Votación",
      description: "Domingo 30 de marzo 2025 a partir de las 9:30",
      details: "Auditorio Municipal de EL Casar - Plaza de la Constitución, 1 El Casar - Guadalajara\n\nMarca esta fecha en tu calendario. Es importante tu participación para el futuro de nuestra comunidad."
    },
    {
      icon: <Users className="w-12 h-12 text-primary" />,
      title: "Cómo delegar el voto",
      description: "Opciones para delegar tu voto",
      details: "Si quieres delegarnos el voto puedes contactar con nosotros vía email o bien acercarte el domingo 30 de marzo de 2025 y entregar tu voto."
    },
    {
      icon: <FileCheck className="w-12 h-12 text-primary" />,
      title: "Documentación Necesaria",
      description: "Deberás presentar:",
      details: "• DNI o documento de identidad válido\n• Justificante de propiedad o residencia en El Coto\n• Acreditación de estar al corriente de pagos"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-primary mb-4">
            Cómo Votar
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Tu voto es importante para el futuro de El Coto. Aquí te explicamos todo lo que necesitas saber para participar en la votación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {votingSteps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-lg shadow-lg p-8"
            >
              <div className="flex flex-col items-center mb-6">
                {step.icon}
                <h3 className="text-2xl font-semibold mt-4 mb-2 text-center">{step.title}</h3>
              </div>
              <p className="text-lg text-gray-700 mb-4">{step.description}</p>
              <p className="text-gray-600 whitespace-pre-line">{step.details}</p>
            </motion.div>
          ))}
        </div>

        {/* Información Adicional */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="bg-white rounded-lg shadow-lg p-8"
        >
          <h2 className="text-2xl font-bold mb-6">Información Importante</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-3">Antes de la Votación</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Verifica que estás al corriente de pagos</li>
                <li>Prepara toda la documentación necesaria</li>
                <li>Infórmate sobre las propuestas de nuestra candidatura</li>
                <li>Solicita cualquier aclaración que necesites</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-3">Contacto para Dudas</h3>
              <p className="text-gray-600">
                Si tienes cualquier duda sobre el proceso de votación, puedes contactarnos:
              </p>
              <ul className="text-gray-600 mt-2">
                <li>Email: marandrada@gmail.com</li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <h2 className="text-3xl font-bold mb-4">
            ¡Tu Voto es Importante!
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Juntos podemos hacer de El Coto un lugar mejor para todos. No olvides ejercer tu derecho al voto.
          </p>
          <Button size="lg" className="mr-4">
            Descarga la Información
          </Button>
          <Button size="lg" variant="outline">
            Contacta con Nosotros
          </Button>
        </motion.div>
      </div>
    </div>
  );
};

export default Vote;
